import { Button, Tooltip } from '@mui/material'
import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { CheckBox, Settings } from '@mui/icons-material'
import { useStudyContext } from '../../Contexts/Modules/StudyModule/SelectedStudyModule'

function StudyPageToggle() {
  const navigate = useNavigate()
  const location = useLocation()
  const { studyQuery } = useStudyContext()
  if (location.pathname.endsWith('configure')) {
    return (
      <Tooltip
        title={
          studyQuery.data?.StudyStatus !== 'ACT' &&
          'Status must be Active to enter Data'
        }
      >
        <span>
          <Button
            onClick={() => {
              navigate(`/stuart/study/${studyQuery.data?.StudyID}/entry/select`)
            }}
            variant={'outlined'}
            disabled={studyQuery.data?.StudyStatus !== 'ACT'}
            endIcon={<CheckBox />}
          >
            Data Entry
          </Button>
        </span>
      </Tooltip>
    )
  } else {
    return (
      <Button
        onClick={() => {
          navigate(`/stuart/study/${studyQuery.data?.StudyID}/configure`)
        }}
        variant={'outlined'}
        disabled={
          location.pathname.includes('sheet') ||
          location.pathname.includes('complete')
        }
        endIcon={<Settings />}
      >
        Configure Study
      </Button>
    )
  }
}

export default StudyPageToggle
